import type { QuizSteps } from "@/types/api.types";
import SingleStepSelect from "@/components/organisms/SingleStepSelect";
import MultipleStepSelect from "@/components/organisms/MultipleStepSelect";
import InfoStep from "@/components/organisms/InfoStep";
import MeasurementStep from "@/components/organisms/MeasurementStep";
import AnalysisLoaderStep from "@/components/organisms/AnalysisLoaderStep";
import OfferPage from "@/components/pages/OfferPage";

const StepRenderer = ({ step, onAnswer, answers, staticLabels }: QuizSteps) => {
  switch (step.type) {
    case "single_select":
      return (
        <SingleStepSelect step={step} answers={answers} onAnswer={onAnswer} />
      );
    case "multi_select":
      return <MultipleStepSelect step={step} onAnswer={onAnswer} />;
    case "info":
      return <InfoStep step={step} onAnswer={onAnswer} answers={answers} />;
    case "measurement":
      return (
        <MeasurementStep
          step={step}
          onAnswer={onAnswer}
          answers={answers}
          staticLabels={staticLabels}
        />
      );
    case "analysis_loader":
      return <AnalysisLoaderStep step={step} onAnswer={onAnswer} />;
    case "offer":
      return <OfferPage step={step} onAnswer={onAnswer} answers={answers} />;
    default:
      return (
        <div className="p-4 text-center text-red-500">Step Doesn't Exist</div>
      );
  }
};

export default StepRenderer;
